export default __webpack_public_path__ + "static/media/users-tab.03f38672.png";